import supabase from "../../../shared/database/supabase";
import { Car } from "../../car";
import { Costumer } from "../../costumer";
import { Pericia } from "../../pericia";

export interface GetInvoiceByIdResponse {
  id: string;
  invoiceCount: number;
  invoiceCustomCount: number;
  invoiceText: string;
  ivaPercentage: number;
  insuranceClaimNumber?: string | null;
  totalPericias: number;
  totalPrice: number;
  payed: boolean;
  payedValue: number;
  payedAt: Date;
  startDate: Date;
  endDate: Date;
  createdAt: Date;
  deleted: boolean;
  updatedAt: Date;
  costumer: Costumer;
  car: Car | null;
  items: InvoiceItem[];
  lines?: InvoiceLineItem[];
}

export interface InvoiceItem {
  pericia: Pericia;
  car: Car;
}

export interface InvoiceLineItem {
  id: string;
  description: string;
  cost: number;
  createdAt: Date;
  deletedAt: Date | null;
  serviceOrderLineType: {
    id: string;
    name: string;
  };
}

export const getInvoiceById = async (id: string): Promise<GetInvoiceByIdResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke("get-invoice-by-id", {
      body: JSON.stringify({ id })
    });
    if (error) throw error;

    if (data.error) throw data.error;

    const items = (data.items || [])
      .map((item: InvoiceItem) => ({
        ...item,
        pericia: {
          ...item.pericia,
          createdAt: new Date(item.pericia.createdAt)
        }
      }))
      .sort((a: InvoiceItem, b: InvoiceItem) => a.pericia.createdAt.getTime() - b.pericia.createdAt.getTime());

    const lines = (data.lines || [])
      .map((line: InvoiceLineItem) => ({
        ...line,
        createdAt: new Date(line.createdAt),
        deletedAt: line.deletedAt ? new Date(line.deletedAt) : null
      }))
      .sort((a: InvoiceLineItem, b: InvoiceLineItem) => a.createdAt.getTime() - b.createdAt.getTime());

    return {
      ...data,
      items,
      lines,
      createdAt: new Date(data.createdAt),
      endDate: new Date(data.endDate),
      payedAt: data.payedAt ? new Date(data.payedAt) : null,
      startDate: new Date(data.startDate)
    };
  } catch (err) {
    console.log(err);
    throw err;
  }
};
